import type { Row } from '@tanstack/table-core/build/lib/types';
import { useDataProvider } from '../DataProviderContext';

export const useIsRowClickable = () => {
  const { isRowClickable, onRowClick } = useDataProvider();

  return (row: Row<any>) => {
    // Row is expandable
    if (row.getCanExpand()) {
      return true;
    }

    if (typeof isRowClickable === 'function') {
      return isRowClickable(row);
    }

    // Clickable, by default, if onRowClick is configured
    return typeof onRowClick === 'function';
  };
};
